// extracted by mini-css-extract-plugin
export default {"avatar":"QkkGzK","withBorder":"Q_LeCO","filter":"NuNqer"};